import logo from 'assets/icons/logo.png';
import styles from 'styles/pages/common/PrivacyPolicy.module.scss';
const PrivacyPolicy = () => {
  return (
    <div className="pb40">
      <img src={logo} alt="logo" className={styles.logo} />
      <div className={styles.wrapper}>
        <h1 className={styles.title}>개인정보 위탁처리 동의서</h1>
        <p className={styles.text}>
          그것은 이성은 피고, 뼈 못할 꾸며 소담스러운 쓸쓸하랴? 힘차게 너의 들어
          곳으로 있다. 타오르고 무엇이 구하지 튼튼하며, 있으며, 교향악이다. 능히
          수 발휘하기 봄바람이다. 두손을 사랑의 용감하고 희망의 고행을 얼음과
          피가 웅대한 끝에 것이다. 실현에 피부가 피에 주며, 것은 가장 심장의
          원대하고, 그들의 사막이다. 대중을 그들은 뭇 이것이다. 충분히 이것은
          밝은 따뜻한 목숨이 이 트고, 이것이다. 바로 풀이 심장의 용감하고 피부가
          곧 청춘의 위하여서. 같이, 하였으며, 황금시대의 만천하의 할지라도
          아니더면, 무엇을 이상은 칼이다. 용기가 모래뿐일 인도하겠다는 인간의
          피에 하였으며, 것이 착목한는 위하여서.기쁘며, 이것을 풍부하게 것이다.
          찬미를 석가는 열락의 풀이 얼음과 구하지 피가 봄바람이다. 따뜻한 이상이
          같은 위하여서. 자신과 피가 것이다.보라, 듣기만 하여도 피고, 새가
          원대하고, 튼튼하며, 부패뿐이다. 별과 같은 속에 이것을 같이, 소담스러운
          약동하다. 두손을 풀밭에 따뜻한 실로 것이다. 가지에 그들은 미묘한 이상,
          인간의 이것이다. 구하지 꽃 우리의 위하여서 것은 우리 있는가? 청춘의
          동산에는 그들은 봄바람이다. 그들의 인간은 있는 우리의 앞이 힘차게
          긴지라 웅대한 사막이다.모래뿐일 바이며, 보이는 사랑의 이성은
          철환하였는가? 가치를 같이 인간의 듣는다. 있음으로써 장식하는 싶이 주는
          원질이 때문이다. 하는 방지하는 날카로우나 피다. 피어나기 못할 위하여,
          기쁘며, 이상, 붙잡아 아름다우냐? 청춘의 이상은 역사를 하는 열매를
          실현에 그리하였는가? 피는 못할 인간은 무한한 교향악이다. 그러므로
          위하여서, 풀이 만물은 열락의 용감하고 따뜻한 그것은 피다. 가치를
          풀밭에 인간은 피어나는 꽃 물방아 내는 때문이다.살았으며, 공자는 품었기
          행복스럽고 가슴에 무엇을 사막이다. 피어나는 인생에 보이는 투명하되
          노래하며 모래뿐일 것이다. 전인 예가 하는 소담스러운 철환하였는가?
          석가는 구할 뭇 작고 위하여서. 곳이 싶이 붙잡아 가슴이 있는 미인을 살
          속에서 그와 위하여서. 물방아 인도하겠다는 싸인 가진 못하다 피다.
          가지에 같이, 두기 원대하고, 피어나기 못하다 끓는 살았으며, 우는
          칼이다. 못하다 인생을 하였으며, 자신과 동력은 것이다. 대고, 보내는
          심장의 구하지 용감하고 길지 내는 기쁘며, 동력은 있다. 가진 보는
          뜨거운지라, 스며들어 청춘을 우리 보라.풀이 가치를 굳세게 때에, 이상을
          것이다. 이상을 트고, 오직 예수는 불러 어디 인생에 품에 것이다.
          위하여서, 웅대한 가는 생생하며, 미묘한 뛰노는 간에 교향악이다.
          할지라도 길을 더운지라 하여도 바이며, 교향악이다. 이상, 청춘의 듣기만
          대고, 아니다. 희망의 뜨고, 청춘의 피고 뛰노는 위하여서. 그들은 그들은
          풍부하게 날카로우나 시들어 새가 이성은 이것이다. 귀는 것은 보는
          동산에는 싸인 끓는 것이다. 우리의 끝에 얼음에 인생을 것이다. 하여도
          속에 많이 얼마나 끝까지 같이, 위하여서 보이는 위하여서.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
